import { createContext } from 'react'
import type { Permissao, UsuarioSessao } from '../api/acesso'

export type EstadoSessao = 'verificando' | 'anonimo' | 'autenticado'

export type Sessao = {
  estado: EstadoSessao
  usuario: UsuarioSessao | null

  /**
   * Fonte única da resposta "pode?". Sempre falso enquanto a sessão está sendo
   * verificada — mostrar um botão antes de saber quem é o usuário e escondê-lo
   * meio segundo depois é pior que esperar.
   */
  pode: (permissao: Permissao) => boolean

  definir: (usuario: UsuarioSessao) => void
  sair: () => Promise<void>
}

export const ContextoSessao = createContext<Sessao | null>(null)
